// extracted by mini-css-extract-plugin
module.exports = {"root":"TransactionPage_root__2nZU9","loading":"TransactionPage_loading__3iDUx","error":"TransactionPage_error__2OwIo","footer":"TransactionPage_footer__2WiO1"};